import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationType = "success" | "error" | "info";

export interface NotificationPayload {
  message: string;
  type: NotificationType;
}

interface NotificationsState {
  current: NotificationPayload | null;
}

const initialState: NotificationsState = {
  current: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification(state, action: PayloadAction<NotificationPayload>) {
      state.current = action.payload;
    },
    clearNotification(state) {
      state.current = null;
    },
  },
});

export const { showNotification, clearNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;

